/**
 * @fileoverview Shared mock adapter for the banking feature.
 * @description The one axios-mock-adapter instance for every banking endpoint, created once and
 * gated by VITE_ENABLE_MOCK_API — mirrors features/sales's sales-mock-adapter.ts exactly, and for
 * the same reason: axios-mock-adapter installs itself by overwriting the axios instance's
 * defaults.adapter, so a second `new MockAdapter(httpClient)` elsewhere would silently replace
 * this one and drop its registered routes. `onNoMatch: 'passthrough'` chains this adapter to
 * whichever one was active before it (sales, then notifications, then auth) so a miss here falls
 * through to them instead of 404ing — this feature's barrel is imported after sales's in
 * app/main.tsx, so this adapter sits last in the passthrough chain.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import MockAdapter from 'axios-mock-adapter'

import { appConfig } from '@/config/app-config'
import { httpClient } from '@/shared/api/http-client'

export const bankingMockAdapter = appConfig.enableMockApi
  ? new MockAdapter(httpClient, { delayResponse: 500, onNoMatch: 'passthrough' })
  : null
